/*
 * Request money screen
 *
 * @return {Element}
 */
<template>
  <div class="content" v-if="!isLoading">
    <req-money-complete
      v-if="isCompleted"
      :isSuccess="isSuccess"
      @refreshScreen="refreshScreen"
    />
    <req-money-setting
      v-else
      @completed="requestCompleted"
      :hasSetting="hasSetting"
      :isPaypal="isPaypal"
      :data="paymentInfo"
    />
  </div>
</template>

<script>
import SettingService from '@/services/settingservice'
import SaleService from '@/services/saleservice'
import ReqMoneySetting from './ReqMoneySetting'
import ReqMoneyComplete from './ReqMoneyComplete'
export default {
  components: {
    ReqMoneySetting,
    ReqMoneyComplete
  },
  data () {
    return {
      paymentInfo: {
        amount: 0,
        bankCode: null,
        bankName: null,
        bankBranchName: null,
        bankBranchCode: null,
        bankDepositcategory: null,
        bankDepositcategoryCode: null,
        bankAccountNumber: null,
        bankAccountName: null,
        paypalAccountName: null,
        paymentMethodCode: null,
        isBankDataActive: true
      },
      isCompleted: false,
      isSuccess: false,
      hasSetting: false,
      isPaypal: false,
      serviceDone: 0,
      isLoading: true,
      loader: null
    }
  },
  created () {
    this.loader = this.$loading.show()
    this.getPaymentInfo()
    this.getPaymentAmount()
  },
  watch: {
    serviceDone (newVal) {
      if (newVal === 2 && this.loader) {
        this.loader.hide()
      }
    }
  },
  methods: {
    /*
     * Get payment info
     *
     * @return void
     */
    getPaymentInfo () {
      SettingService.getPaymentInfo()
        .then((response) => {
          if (response.withdrawal && Object.keys(response.withdrawal).length > 0) {
            const {
              paymentMethodCode,
              paypalAccountName,
              ...rest
            } = response.withdrawal
            this.hasSetting = ((paymentMethodCode === '10' && !Object.values(rest).some(el => !el)) || (paymentMethodCode === '7A' && paypalAccountName !== null))
            this.isPaypal = (paymentMethodCode === '7A')
            this.paymentInfo = {
              ...this.paymentInfo,
              ...response.withdrawal
            }
          } else {
            this.hasSetting = false
          }
          this.isLoading = false
          this.serviceDone += 1
        })
        .catch((err) => {
          this.err = err
        })
    },
    /*
     * Call API to get payment amount
     *
     * @return void
     */
    getPaymentAmount () {
      SaleService.getPaymentAmount()
        .then((response) => {
          if (response.amount <= 0) {
            this.$router.push('/revenue')
          } else {
            this.paymentInfo.amount = response.amount
          }
          this.serviceDone += 1
        })
    },
    /*
     * Show request payment completed screen
     *
     * @param {Boolean} isSuccess Request payment success or fail
     *
     * @return void
     */
    requestCompleted (isSuccess) {
      this.isCompleted = true
      this.isSuccess = isSuccess
    },
    /*
     * Refresh to init screen
     *
     * @return void
     */
    refreshScreen () {
      this.serviceDone = 0
      this.isCompleted = false
      this.getPaymentInfo()
      this.getPaymentAmount()
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/revenue/ReqMoney.vue